// src/API/basic/agendamento/Deletar.js
export async function Deletar(grupo, inicio) {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_IP}/agenda/delete`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ grupo, inicio })
    }
  );

  // ❯❯ devolve o Response sem consumir o body
  return response;
}
